<template>
  <div class="card">
    <h5 class="card-header">Roles</h5>
    <div class="card-body">
      <div v-if="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
        {{ successMessage }}
        <button type="button" class="close" @click="successMessage = null" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <ErrorSummary :error="error" />
      <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
        <div class="form-group" v-for="r in allRoles" :key="r.code">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" :value="r.code" :id="r.code" v-model="roles" :disabled="loadingMessage" />
            <label class="form-check-label" :for="r.code"
              >{{ r.shortDescription }} <small class="form-text text-muted">{{ r.longDescription }}</small></label
            >
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer">
      <button type="button" class="btn btn-primary btn-block" @click="submit" :disabled="loadingMessage" @keyup.enter="signIn">
        <span v-if="loadingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ loadingMessage ? loadingMessage : "Save" }}
      </button>
    </div>
  </div>
</template>

<script>
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  props: {
    organizationId: String,
    userId: String,
  },
  data() {
    return {
      loadingMessage: null,
      formWasValidated: false,
      successMessage: null,
      error: null,

      allRoles: [],
      roles: [],
    };
  },
  created() {
    this.load();
  },
  watch: {
    organizationId() {
      this.load();
    },
    userId() {
      this.load();
    },
  },
  methods: {
    load() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/roles`)
        .then(res => (this.allRoles = res.data))
        .then(() => this.$axios.get(`/v1/organizations/${this.organizationId}/users/${this.userId}/roles`).then(res => (this.roles = res.data.roles)))
        .catch(() => this.$router.push(`/organizations/${this.organizationId}/users`))
        .finally(() => (this.loadingMessage = null));
    },
    reset() {
      this.loadingMessage = null;
      this.formWasValidated = false;
      this.successMessage = null;
      this.error = null;
    },
    submit() {
      const payload = {
        roles: this.roles,
      };

      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // api
      this.loadingMessage = "Saving...";
      this.$axios
        .put(`/v1/organizations/${this.organizationId}/users/${this.userId}/roles`, payload)
        .then(() => (this.successMessage = "Save successful!"))
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>
